import dynamicAccountButtons from '@modules/dynamicAccountButtons';
import { fetchUserGuest } from '@helpers/fetchUserGuest';

/**
 * Initialize dynamic account buttons by fetching user status
 * and updating button text/links accordingly
 */
export default async function init() {
  const isGuest = await fetchUserGuest();
  dynamicAccountButtons(isGuest);
}
